import Head from "next/head";
import { useRouter } from "next/router";
import { env } from "process";
import useSWR from "swr";
import { getLatestBlogs, getTagData } from "../lib/api";
import Layout from "./layout";
import CommonBlogPreview from "./Layout/common-blog-preview";
import Loader from "./Loader";
import SidebarPWA from "./PWA/SidebarPWA";
import SEOMeta from "./SEOMeta";
import SidebarBlog from "./sidebar-blog-post";
import SearchForm from "./sidebar/SearchForm";

export default function Tag() {

  const liveURL = env.NEXT_PUBLIC_SITE_URL;

  const router = useRouter();
  const { slug } = router.query;

  type LoadingState = {
    isLoadingBlog?: boolean;
    isLoadingLatestPosts?: boolean;
  };

  const {
    data: blogsData,
    isValidating: isLoadingBlogs,
    error: blogsLoadingError,
  } = useSWR(`/api/tags/${slug}`, (url) => getTagData(slug).then((res) => res));
  const blogs = blogsData?.edges;

  const {
    data: latestPostsData,
    isValidating: isLoadingLatestPosts,
    error: latestPostsLoadingError,
  } = useSWR("/api/latest-posts", (url) =>
    getLatestBlogs(5).then((res) => res)
  );
  const latestPosts = latestPostsData?.edges;
  const tag = blogs?.[0]?.node;
  const tagPosts = tag?.posts;
  
  //console.log(liveURL);

  return (
    <Layout>
      {/* {tag && (
        <Head>
          <title>{tag && tag?.seo?.title ? tag?.seo?.title : "Tag"}</title>          
            <SEOMeta
              type="tag"
              desc={tag?.seo?.title ? tag?.seo?.title : "Gossipment Tag"}
            />        
        </Head>
      )} */}

      <Head>
        <title>{tag?.seo?.title ? tag?.seo?.title : "Tag"}</title>
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
        <meta
          name="description"
          content={
            tag?.seo?.title ? "Gossipment " + tag?.seo?.title : "Gossipment Tag"
          }
        />
        <link rel="canonical" href={'https://gossipment.com/'+slug} />
      </Head>

      <main className="blog-page-main-sec trending-post-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <header className="blog-page-dsc mb-4">
                <h2 className="page-title text-center mt-3">
                  Tag :{" "}
                  {tag?.name ?? (
                    <span className="text-capitalize">
                      {((slug ?? "") as string).replace("-", " ")}
                    </span>
                  )}
                </h2>

                {tag?.description != "" ? (
                  <p className=" text-center mt-3">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: tag && tag?.description,
                      }}
                    />
                  </p>
                ) : (
                  ""
                )}
              </header>
            </div>

            <div className="col-lg-8">
              <div className="celebrity-sec-card-whapper mb-5 post-grid-wrapper">
                <Loader isLoading={isLoadingBlogs} />
                {blogsLoadingError && <span>{blogsLoadingError.message}</span>}

                {tag &&
                  tagPosts &&
                  tagPosts?.edges &&
                  tagPosts?.edges?.map((posts) => (
                    <CommonBlogPreview
                      key={posts.node.slug}
                      title={posts.node.title}
                      categories={posts.node.categories}
                      coverImage={posts.node.featuredImage}
                      date={posts.node.date}
                      slug={posts.node.slug}
                    />
                  ))}
              </div>
            </div>
            <div className="col-lg-4 mb-5">
              <aside className="aside-bar">
                <SearchForm />
                <hr />
                <Loader isLoading={isLoadingLatestPosts} />
                {latestPostsLoadingError && (
                  <span>{latestPostsLoadingError.message}</span>
                )}

                <SidebarPWA/>
                <hr />

                {latestPosts?.length && (
                  <SidebarBlog posts={latestPosts} title="Recent News" />
                )}
              </aside>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}
